/********************************************************************************
 * Copyright (c) 2019 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
export function isSuccess(obj) {
    const success = obj?.success;
    return typeof success === 'string';
}
export function isError(obj) {
    const error = obj?.error;
    return typeof error === 'string' && Boolean(error);
}
export const VERSION_ALIASES = ['latest', 'pre-release'];
export function isEqualUser(u1, u2) {
    return u1.loginName === u2.loginName;
}
export const CATEGORIES = [
    'AI',
    'Programming Languages',
    'Snippets',
    'Linters',
    'Themes',
    'Debuggers',
    'Formatters',
    'Keymaps',
    'SCM Providers',
    'Other',
    'Extension Packs',
    'Language Packs',
    'Data Science',
    'Machine Learning',
    'Visualization',
    'Notebooks'
];
export var TierType;
(function (TierType) {
    TierType["FREE"] = "FREE";
    TierType["SAFETY"] = "SAFETY";
    TierType["NON_FREE"] = "NON_FREE";
})(TierType || (TierType = {}));
export var RefillStrategy;
(function (RefillStrategy) {
    RefillStrategy["GREEDY"] = "GREEDY";
    RefillStrategy["INTERVAL"] = "INTERVAL";
})(RefillStrategy || (RefillStrategy = {}));
export var EnforcementState;
(function (EnforcementState) {
    EnforcementState["EVALUATION"] = "EVALUATION";
    EnforcementState["ENFORCEMENT"] = "ENFORCEMENT";
})(EnforcementState || (EnforcementState = {}));
//# sourceMappingURL=extension-registry-types.js.map